import { SVGProps } from 'react';
import { SvgSymbolIds } from '../constants';
export function IconClose(props: SVGProps<SVGSVGElement>) {
  return <svg {...props} data-sentry-element="svg" data-sentry-component="IconClose" data-sentry-source-file="close.tsx">
            <use href={`#${SvgSymbolIds.Close}`} data-sentry-element="use" data-sentry-source-file="close.tsx" />
        </svg>;
}